import React, { useState } from "react";
import UserHeader from "./UserHeader";
import { ToastContainer, toast } from "react-toastify";
import { updateUserpassword } from "../../Utils/userFunctions";
import * as Constant from "../../Utils/constants";
const UserChangePassword = () => {
  const [passwordError, setPasswordErr] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [currentPasswordError, setCurrentPasswordError] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const handleValidation = (event) => {
    const passwordInputValue = event.target.value.trim();
    const passwordLength = passwordInputValue.length;
    const uppercasePassword = Constant.UPPERCASE.test(passwordInputValue);
    const lowercasePassword = Constant.LOWERCASE.test(passwordInputValue);
    const digitsPassword = Constant.DIGITS.test(passwordInputValue);
    const specialCharPassword = Constant.SPECIALCHAR.test(passwordInputValue);
    const minLengthPassword = Constant.MINLENGTH.test(passwordInputValue);
    let errMsg;
    if (passwordLength === 0) {
      errMsg = "Password is empty";
    } else if (!uppercasePassword) {
      errMsg = "At least one Uppercase";
    } else if (!lowercasePassword) {
      errMsg = "At least one Lowercase";
    } else if (!digitsPassword) {
      errMsg = "At least one digit";
    } else if (!specialCharPassword) {
      errMsg = "At least one Special Characters";
    } else if (!minLengthPassword) {
      errMsg = "At least minumum 8 characters";
    } else {
      errMsg = "";
    }
    setPasswordErr(errMsg);
  };
  const handleChangePasword = async () => {
    const formData = new FormData();
    if (currentPassword.length === 0) {
      setCurrentPasswordError("Current Password is empty");
    } else if (password.length === 0) {
      setPassword("New Password is empty");
    } else if (confirmPassword !== password) {
      setConfirmPasswordError(
        "'Confirm new' password and 'new password' does not match"
      );
    } else {
      setCurrentPasswordError("");
      setPasswordErr("");
      setConfirmPasswordError("");
      formData.append("current_password", currentPassword);
      formData.append("password", password);
      const response = await updateUserpassword(formData);
      if (response.status === "success") {
        setCurrentPassword("");
        setPassword("");
        setConfirmPassword("");
        toast.success(response.message, { autoClose: 1500 });
      } else {
        toast.warning(response.message, { autoClose: 1500 });
      }
    }
  };
  return (
    <div>
      <ToastContainer></ToastContainer>
      <UserHeader />
      <div className="container">
        <div className="row mt-4">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="card vd-card">
              <div className="card-header">
                <div className="d-flex align-items-center mb-4">
                  <div className="mr-auto">
                    <h4 className="card-title">Change Password</h4>
                  </div>
                </div>
                <div className="profile-content-edit p-3">
                  <div className="row">
                    <span
                      for="Current Password"
                      className="col-sm-2 col-form-label"
                    >
                      Current Password
                    </span>
                    <div className="col-md-3 col-sm-10">
                      <input
                        type="password"
                        className="form-control"
                        value={currentPassword}
                        onChange={(e) => {
                          setCurrentPassword(e.target.value);
                          setCurrentPasswordError("");
                        }}
                        placeholder="Current Password *"
                        autoFocus
                      ></input>
                      <p style={{ color: "red" }}>{currentPasswordError}</p>
                    </div>
                  </div>
                  <div className="row">
                    <span
                      for="New Password"
                      className="col-sm-2 col-form-label"
                    >
                      New Password
                    </span>
                    <div className="col-md-3 col-sm-10">
                      <input
                        type="password"
                        className="form-control"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          setPasswordErr("");
                        }}
                        onKeyUp={handleValidation}
                        placeholder="New Password *"
                        autoFocus
                      ></input>
                      <p style={{ color: "red" }}>{passwordError}</p>
                    </div>
                  </div>
                  <div className="row">
                    <span
                      htmlFor="Confirm Password"
                      className="col-sm-2 col-form-label"
                    >
                      Confirm Password
                    </span>
                    <div className="col-md-3 col-sm-10">
                      <input
                        type="password"
                        className="form-control"
                        value={confirmPassword}
                        onChange={(e) => {
                          setConfirmPassword(e.target.value);
                          setConfirmPasswordError("");
                        }}
                        placeholder="Confirm Password*"
                      ></input>
                      <p style={{ color: "red" }}>{confirmPasswordError}</p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <button
                      className="btn btn-primary mt-3 pull-left custom-btn-primary"
                      onClick={handleChangePasword}
                    >
                      Change Password
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserChangePassword;
